import {axiosGetHandler, axiosPostHandler} from './config'
import {AxiosResponse} from "axios";
import {ResponseType, ResponseTypePagination} from "_types/common";
import {BotInfo, IRoom, ISignInRule, TaskConfig} from "@/views/bot/types";
import {extractAPIValues} from '_lib/utils/utils'
import { TaskType } from '_lib/constants/bot';
const {BASE_API, BASE_XHH} = extractAPIValues()


// 邀请 bot 进房间
export function inviteBot(args: any, formData: {
    room_id: string,
    bot_id: number,
    nonce: string,
}): ResponseType<any> {
    let url = BASE_API + '/chatroom/v2/bot/invite_to_room'
    return axiosPostHandler(url, args, formData)
}

// 获取管理的房间列表
export function allManagedRooms(args: {bot_id: number, limit: number, offset: number}): ResponseType<{
    data?: IRoom[]
}> {
    let url = BASE_API + '/chatroom/v2/room/manage_list'
    return axiosGetHandler(url, args)
}

export function allManagedRoomsPerPage(
    args: {
        bot_id: number,
        offset: number,
        limit: number,
    }
): ResponseTypePagination<{
    data: {
        total: number,
        limit: number,
        offset: number,
        rooms: IRoom[],
    }
}> {
    let url = BASE_API + '/chatroom/v2/room/manage_page'
    return axiosGetHandler(url, args)
}

export function botInfo(args:{
    bot_id: number
}): ResponseType<{
    view: BotInfo,
}> {
    let url = BASE_API + '/chatroom/v2/bot/view'
    return axiosGetHandler(url, args)
}

type BotPermission = {
    id: string,
    type: number,
    allow: boolean,
}
export function updateBotInfo(args: object, formData: {
    room_id: string,
    bot_id: number,
    permissions: BotPermission[],
}): ResponseType<any> {
    let url = BASE_API + '/chatroom/v2/room/bot/update/setting'
    return axiosPostHandler(url, args, formData)
}

export function addTask(args: object, formData: {
    room_id: string,
    lottery_id: string,
    task_name: string,
    task_type: TaskType,
    push_content: string,
    task_config: TaskConfig,
}): ResponseType<any> {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/task/create'
    return axiosPostHandler(url, args, formData)
}

export function updateTask(args: object, formData: {
    room_id: string,
    lottery_id: string,
    task_id: string,
    task_name: string,
    task_type: TaskType,
    task_config: TaskConfig,
}): ResponseType<any> {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/task/update'
    return axiosPostHandler(url, args, formData)
}

export function deleteTask(args: object, formData: {
    room_id: string,
    lottery_id: string,
    task_id: string
}): ResponseType<any> {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/task/del'
    return axiosPostHandler(url, args, formData)
}

// 上报
// 获取用户认证状态
export function getApplyState (args: { heybox_id: string }) {
	let url = BASE_XHH + '/mall/developer/apply/own/short_dtl/'
	return axiosGetHandler(url, args)
}
// 获取机器人平台推荐列表
export function getRecommendBotList (args: { offset: number, limit: number }) {
    let url = BASE_API + '/chatroom/v2/bot/recommend/list'
    return axiosGetHandler(url, args)
}

// 搜索机器人平台列表
export function getSearchBotList(args: { 
    query: string, 
    category_id: number, 
    app_id: number, 
    offset: number, 
    limit: number 
}) {
    let url = BASE_API + '/chatroom/v2/bot/search'
    return axiosGetHandler(url, args)
}

// 获取机器人分类
export function getBotCategories() {
    let url = BASE_API + '/chatroom/v2/bot/categories'
    return axiosGetHandler(url)
}


// 获取bot详情
export function getRecommendBotDetail (args: { bot_id: number }) {
    let url = BASE_API + '/chatroom/v2/bot/open/view'
    return axiosGetHandler(url, args)
}

// 获取消息状态
// INFO: 等待后续产品变化
// export function getCheckLotteryPart(args: { msg_ids: number }) {
//     let url = BASE_API + '/heybot/lottery/participate/check'
//     return axiosGetHandler(url, args)
// }

// 自动回复列表
export function getAutoReplyList(args: { room_id: string }) {
    let url = BASE_API + '/chatroom/v2/heybot/auto_reply/list'
    return axiosGetHandler(url, args)
}

// 编辑自动回复
export function upsertAutoReply(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/heybot/auto_reply/upsert'
    return axiosPostHandler(url, args, formData)
}

// 获取签到规则列表
export function getSignInRuleList(args: object, formData: object): ResponseType<{
    rules: ISignInRule
}> {
    let url = BASE_API + '/chatroom/v3/bot/checkin/rules'
    return axiosPostHandler(url, args, formData)
}

// 保存签到规则
export function saveSignInRule(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v3/bot/checkin/save'
    return axiosPostHandler(url, args, formData)
}

// 获取房间积分奖品列表
export function getRoomPointsPrizes(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/bot/points/prizes/list'
    return axiosPostHandler(url, args, formData)
}
// 保存房间积分奖品
export function saveRoomPointsPrizes(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/bot/points/prizes/save'
    return axiosPostHandler(url, args, formData)
}

// 刷新手动抽奖用户
export function refreshManualLotteryUsers(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/winners/refresh'
    return axiosPostHandler(url, args, formData)
}

// 确认中奖用户
export function confirmLotteryWinners(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/winners/confirm'
    return axiosPostHandler(url, args, formData)
}

// 中奖用户列表 也是开始手动抽奖
export function getLotteryWinners(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/winners/list'
    return axiosPostHandler(url, args, formData)
}

// 搜索用户参与情况
export function searchUserParticipation(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v2/heybot/lottery/search_participate'
    return axiosPostHandler(url, args, formData)
}

// 充值积分
export function rechargePoints(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v3/bot/points/recharge'
    return axiosPostHandler(url, args, formData)
}

// 分页获取充值用户列表
export function getRechargeUserList(args: object) {
    let url = BASE_API + '/chatroom/v3/bot/points/recharge'
    return axiosGetHandler(url, args)
}

// 清空所有用户积分
export function clearAllUserPoints(args: object, formData: object) {
    let url = BASE_API + '/chatroom/v3/bot/points/clear'
    return axiosPostHandler(url, args, formData)
}